import axios from "axios";

export default {
    postUser(obj){
        return axios.post(`/register`,obj);
    },
    getUsers() {
        return axios.get(`/users`);
    },
    putUser(id, obj) {
        return axios.put(`/users/${id}`, obj);
    },
    deleteUser(id) {
        return axios.delete(`/users/${id}`);
    },
    resetPwd(obj){
        axios.defaults.headers.common = {}
        return axios.post(`/users/password/reset`,obj);
    },
    updatePwd(obj){
        return axios.post(`/users/password/update`,obj);
    }
};
